import styled, { keyframes } from 'styled-components';

export const ChatMessageWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  margin-bottom: 20px;
  margin-top: 20px;
  max-width: 70%;
  flex-direction: ${({ type }) => (type === 'candidate' ? 'row-reverse' : 'row')};
  margin-left: ${({ type }) => (type === 'candidate' ? 'auto' : '0')};
  margin-right: ${({ type }) => (type === 'candidate' ? '20px' : '0')};

  @media (max-width: 800px) {
    max-width: ${({ type }) => (type === 'candidate' ? '90%' : '95%')};
    margin-left: ${({ type }) => (type === 'candidate' ? 'auto' : '0')};
    margin-right: ${({ type }) => (type === 'candidate' ? '0px' : '0')};

    .audio {
      max-width: 270px;
    }

  }

`;

export const MessageText = styled.div`
  background-color: ${({ type }) => (type === 'coach' ? '#e7f5ff' : '#d1e7dd')};
  padding: 10px;
  border-radius: 10px;
  color: black;
  max-width: 100%;
  word-wrap: break-word;
  margin-left: ${({ type }) => (type === 'coach' ? '10px' : '0')};
  margin-right: ${({ type }) => (type === 'candidate' ? '10px' : '0')};
  word-break: break-word;
  display: flex;
  flex-direction: column; /* Ensure the audio is below the text */
  align-items: flex-start; /* Ensure items are aligned to the start */

  @media (max-width: 800px) {
    margin-left: ${({ type }) => (type === 'coach' ? '05px' : '0')};
    margin-right: ${({ type }) => (type === 'candidate' ? '05px' : '0')};
  }

  audio {
    margin-top: 10px; /* Add margin to separate audio from text */
  }
`;

const blink = keyframes`
  0% { opacity: 0.2; }
  20% { opacity: 1; }
  100% { opacity: 0.2; }
`;

export const LoadingDots = styled.span`
  display: inline-block;
  &:after {
    content: '...';
    animation: ${blink} 1.4s infinite both;
  }
`;

export const UserAvatar = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  overflow: hidden;
  flex-shrink: 0;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;
